import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sessionsEndpoints } from '../../../endpoints/sessions';
import { ICreateSessionInput } from '../../../models/sessions';

/**
 * Mutation per creare una sessione manuale (form rapido senza file).
 * Invalida la query tabella per refresh automatico.
 */
export function useCreateSession() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: ICreateSessionInput) =>
      (await sessionsEndpoints.create(input)).data,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['sessions-table'] });
      qc.invalidateQueries({ queryKey: ['sessions-athlete'] });
    },
  });
}
